import { useEffect } from 'react'
import type { FC } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

import { queueNotification } from '~/shared/notifications/actions'
import { AppointmentEntry } from '~/features/member-profile/clinical/appointments'

const FullscreenVideo: FC = () => {
  const { id } = useParams()
  const dispatch = useDispatch()

  // Start and track visit
  useEffect(() => {
    if (!id) {
      dispatch(queueNotification({ message: 'Appointment ID not found', variant: 'error' }))
    }
  }, [id, dispatch])

  return id ? <AppointmentEntry id={id} modal={false} /> : null
}

export default FullscreenVideo
